<template>
  <div class="d-flex align-items-start flex-wrap">
    <template v-if="showChips">
      <span
        v-for="label in labels"
        :key="label.id"
        :style="{ background: '#' + label.color }"
        class="me-2 py-1 ps-2 pe-2 rounded"
      >
        {{ label.label }}
        <span
          @click.stop.prevent="$emit('remove', label.id)"
          style="cursor: pointer"
        >
          <fa-icon name="trash-alt" />
        </span>
      </span>
    </template>
    <div
      class="position-relative input-group input-group-sm col-3 ps-0 ms-0 py-0 my-0"
    >
      <input
        ref="labelinput"
        class="form-control form-control-sm py-0"
        v-model="query"
        placeholder="Add label"
        type="text"
        autocomplete="off"
        @input="oninput"
        @focus="oninput"
        @keyup.down.prevent="moveactive(1)"
        @keyup.up.prevent="moveactive(-1)"
        @keyup.enter.prevent="selectactive"
        @keyup.escape.prevent="close"
      />
      <div
        ref="dropdown"
        v-show="open"
        class="position-absolute w-100 mt-1 list-group shadow"
        style="z-index: 1050"
      >
        <button
          v-for="(row, idx) in rows"
          :key="row.key"
          type="button"
          class="list-group-item list-group-item-action py-1 px-2 d-flex align-items-center"
          :class="{ active: activeindex === idx }"
          @mousedown.prevent="pick(row)"
        >
          <span
            v-if="row.create"
          >
            Create
            <span class="fw-bold">"{{ row.label }}"</span>
          </span>
          <span
            v-else
            :style="{ background: '#' + row.color }"
            class="me-2 py-0 ps-1 pe-1 rounded"
          >
            <fa-icon name="tag" />
          </span>
          <span v-if="!row.create">{{ row.label }}</span>
        </button>
        <div class="list-group-item py-1 px-2 text-secondary small border-top-0">
          Start typing to find or add a new label
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConsultantLabelPicker',
  props: {
    consultantId: {
      type: Number,
      required: true
    },
    labels: {
      type: Array,
      default: () => []
    },
    showChips: {
      type: Boolean,
      default: true
    },
    autofocus: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      alllabels: [],
      query: '',
      open: false,
      activeindex: 0
    };
  },
  computed: {
    assignedlabels() {
      return this.labels.map((l) => l.label.toLowerCase());
    },
    cancreate() {
      const q = this.query.trim().toLowerCase();
      if (q === '') return false;
      return !this.alllabels.some((l) => l.label.toLowerCase() === q);
    },
    rows() {
      const rows = [];
      if (this.cancreate) {
        rows.push({
          key: 'create',
          create: true,
          label: this.query.trim()
        });
      }
      const q = this.query.trim().toLowerCase();
      this.alllabels
        .filter(
          (l) =>
            !this.assignedlabels.includes(l.label.toLowerCase()) &&
            (q === '' || l.label.toLowerCase().includes(q))
        )
        .slice(0, 6)
        .forEach((l) => {
          rows.push({
            key: l.id,
            create: false,
            label: l.label,
            color: l.color
          });
        });
      return rows;
    }
  },
  created() {
    this.labels_get();
  },
  mounted() {
    document.addEventListener('mousedown', this.ondocumentdown);
    if (this.autofocus) this.$refs.labelinput.focus();
  },
  beforeUnmount() {
    document.removeEventListener('mousedown', this.ondocumentdown);
  },
  methods: {
    labels_get() {
      this.$store
        .dispatch('labels_get')
        .then((resp) => {
          this.alllabels = resp.data;
        });
    },
    ondocumentdown(event) {
      if (!this.$el.contains(event.target)) this.close();
    },
    oninput() {
      this.activeindex = 0;
      this.open = true;
      this.$nextTick(() => this.positiondropdown());
    },
    positiondropdown() {
      const dd = this.$refs.dropdown;
      const input = this.$refs.labelinput;
      if (!dd || !input) return;
      const rect = input.getBoundingClientRect();
      dd.style.top = 'auto';
      dd.style.bottom = 'auto';
      const h = dd.offsetHeight;
      if (rect.bottom + h > window.innerHeight - 8) {
        dd.style.bottom = rect.height + 4 + 'px';
      } else {
        dd.style.top = '4px';
      }
    },
    moveactive(delta) {
      if (this.rows.length === 0) return;
      this.activeindex =
        (this.activeindex + delta + this.rows.length) % this.rows.length;
    },
    selectactive() {
      const row = this.rows[this.activeindex];
      if (!row) return;
      this.pick(row);
    },
    pick(row) {
      this.$emit('add', row.label);
      this.query = '';
      this.open = false;
      if (row.create) this.labels_get();
    },
    close() {
      this.open = false;
      this.query = '';
      this.$emit('close');
    }
  }
};
</script>
